'use client';
import type { News } from '@/types';

import { Box, Image, Link, Text } from '@/components';
import { useTranslation } from '@/hooks';
import { routes } from '@/statics';

const ReadMoreBlogs: React.FC<{ mostVisitedNews: News[] }> = ({
  mostVisitedNews,
}) => {
  const { t } = useTranslation('pages');
  return (
    <>
      <Box
        borderRadius="md"
        width={{ base: '100%', md: '45%', lg: '30%' }}
        paddingInline="16px"
        paddingBlock="25px"
        backgroundColor="white"
        border="1px solid"
        borderColor="primary.50"
      >
        <Text fontSize={{ base: 'lg', lg: 'xl' }} fontWeight="bold">
          {t('blog.readMore')}
        </Text>
        {mostVisitedNews.map((post) => {
          return (
            <Link
              href={routes.blog.href(post.code)}
              key={post.id}
              display="block"
            >
              <Box
                display="flex"
                alignItems="flex-start"
                flexBasis="100%"
                marginTop="35px"
              >
                <Box
                  aspectRatio={113 / 81}
                  width="40%"
                  sx={{
                    '& img': {
                      aspectRatio: '113 / 81',
                      width: '100%',
                      objectFit: 'cover',
                      borderRadius: 'lg',
                    },
                  }}
                  position="relative"
                >
                  <Image src={post.preview_image} alt={post.alt_image} fill />
                </Box>
                <Text marginRight="14px" lineHeight="33px" width="60%">
                  {post.title}
                </Text>
              </Box>
            </Link>
          );
        })}
      </Box>
    </>
  );
};
export default ReadMoreBlogs;
